'use strict';

import formPrepare from './pages/checkout/formPrepare';
import util from './util';
const maxFileSize = SitePreferences.UPLOAD_FILE_SIZE_LIMIT;

var regex = {
	phone: {
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        other: /(^[0-9]{9,18}$)|(^[00][0-9]{1,3}[0-9]{9,18}$)/,
        gb: /(^(0)(70|71|73|74|75|76|77|78|79)([0-9]{5,8})$)|(^(7624)([0-9]{3,6})$)/,
        fr: /(^(0)([0-9]{9,9})$)/,
        es: /(^([0-9]{9,9})$)/,
        pt: /(^[0-9]{9,11}$)/,
        de: /(^(0)([0-9]{6,13})$)/,
        it: /(^[0-9]{0,11}$)/,
        nl: /(^(0)([0-9]{8,9})$)/,
        se: /(^(0)[0-9]{7,13}$)/,
        ie: /(^(0)[0-9]{7,11}$)/,
        dk: /(^[0-9]{0,8}$)/,
        be: /(^(0)([0-9]{8,9})$)/,
        gr: /(^[0-9]{10,10}$)/,
        at: /(^(0)([0-9]{4,13})$)/,
        fi: /(^(0)[0-9]{4,13}$)/,
        pl: /(^[0-9]{9,9}$)/,
        ro: /(^(0)[0-9]{9,9}$)/,
        cz: /(^[0-9]{4,12}$)/,
        hu: /(^(6|7)[0-9]{8,9}$)/,
        sk: /(^(0)[0-9]{4,9}$)/,
        mt: /(^[0-9]{8,9}$)/,
        lt: /(^(8)[0-9]{8,8}$)/,
        hr: /(^(0)[0-9]{10,10}$)/,
        lu: /(^([0-9]{4,11})$)/,
        si: /(^(0)[0-9]{7,9}$)/,
        ee: /(^[0-9]{7,10}$)/,
        cy: /(^[0-9]{8,11}$)/,
        lv: /(^[0-9]{7,8}$)/,
        bg: /(^(0)[0-9]{7,9}$)/
    },
    postal: {
    	at:/^\d{4}$/,
    	be:/^\d{4}$/,
    	nl:/^\d{4}[ ][A-Z]{2}$/,
    	lu:/^\d{4}$/,
    	es:/^\d{5}$/,
    	bg:/^\d{4}$/,
    	cy:/^\d{4}$/,
    	cz:/^\d{3}[ ]\d{2}$/,
    	dk:/^\d{4}$/,
    	ee:/^\d{5}$/,
    	fi:/^\d{5}$/,
    	gr:/^\d{3}[ ]\d{2}$/,
    	hu:/^\d{4}$/,
    	lv:/^(LV-)[0-9]{4}$/,
    	lt:/^\d{5}$/,
    	lu:/^\d{4}$/,
    	mt:/^[A-Z]{3}[-]\d{3,4}$/,
    	pl:/^\d{2}[-]\d{3}$/,
    	pt:/^\d{4}[-]\d{3}$/,
    	ro:/^\d{6}$/,
    	sk:/^\d{3}[ ]\d{2}$/,
    	si:/^\d{4}$/,
    	se:/^\d{3}[ ]\d{2}$/,
    	de:/^\d{5}$/,
    	fr:/^\d{5}$/,
    	ie:/^(?:[A-Z0-9]){3}[ ](?:[A-Z0-9]){4}$/,
    	it:/^\d{5}$/,
    	gb:/^(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4})$/
    },
	phoneExampleByCountry : {
        at: '06642143512',
        de: '015123456789',
        be: '0474123456',
        nl: '061234567',
        lu: '621123456',
        fr: '0622334455',
        gb: '07911123456',
        it: '3342069999',
        es: '611222333',
        ie: '012345678901',
        bg: '0123456789',
        hr: '01234567890',
        cy: '12345678901',
        cz: '123456789012',
        dk: '12345678',
        ee: '1234567890',
        fi: '08123456789012',
        gr: '1234567890',
        hu: '6123456789',
        lv: '12345678',
        lt: '812345678',
        mt: '612345678',
        pl: '123456789',
        pt: '6234567890',
        ro: '0123456789',
        sk: '0112456789',
        si: '0612345678',
        se: '01234567890123'
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    /*
     * "de_DE" äöüÄÖÜß \u00E4\u00F6\u00FC\u00C4\u00D6\u00DC\u00DF
	 * "es_ES" áéíóúüñÁÉÍÓÚÜÑ \u00E1\u00E9\u00ED\u00F3\u00FA\u00FC\u00F1\u00C1\u00C9\u00CD\u00D3\u00DA\u00DC\u00D1
	 * "fr_FR" àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ \u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00E7\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00C7
	 * "it_IT" àèéìòóùÀÈÉÌÒÓÙ \u00E0\u00E8\u00E9\u00EC\u00F2\u00F3\u00F9\u00C0\u00C8\u00C9\u00CC\u00D2\u00D3\u00D9
	 * "nl_NL" áéíóúàèëïöüĳÁÉÍÓÚÀÈËÏÖÜĲ \u00E1\u00E9\u00ED\u00F3\u00FA\u00E0\u00E8\u00EB\u00EF\u00F6\u00FC\u0133\u00C1\u00C9\u00CD\u00D3\u00DA\u00C0\u00C8\u00CB\u00CF\u00D6\u00DC\u0132
     */
    name: /^[A-ZÀÁÂÃÄÅĀĂĄǍȀȂȦǠẠḀǺḂḄḆĆČÇḈĈĊĎḐḒḊḌḎÐÉĔĚȨḜÊẾỆỀỂỄḘËĖẸȄÈẺȆĒḖḔĘẼḚḞḟǴĞǦĢĜĠḠḪȞḨĤḦḢḤÍĬǏÎÏḮİỊȈÌỈȊĪĮĨĴǰĵḰǨĶḲḴĹĽĻḼḶḸḺŁḾṀṂŃŇŅṊṄṆǸÑÓŎǑÔỐỘỒỔỖÖȪȮȰỌŐȌÒỎƠỚỢỜỞỠȎŌṒṐǪǬÕṌṎȬǾŒṔṖŔŘŖṘṚṜȐȒṞŚṤŠṦŞŜȘṠṢŤŢṰȚṪṬṮÚŬǓÛṶÜǗǙǛǕṲỤŰȔÙỦƯỨỰỪỬỮȖŪṺŲŮŨṸṴẂŴẄẆẈẀẌẊÝŶŸẎỴỲỶȲỸŹŽẐŻẒẔǮa-zàáâãäåāăąǎȀȂȦǠạḀǻḁḃḅḇćčçḉĉċďḑḓḋḍḏðéĕěȩḝêếệềểễḙëėẹȅèẻȇēḗḕęẽḛḟǵğǧģĝġḡḫȟḩĥḧḣḥẖíĭǐîïḯịȉìỉȋīįĩḭĵḱǩķḳḵĺľļḽḷḹḻłḿṁṃńňņṋṅṇǹñóŏǒôốộồổỗöȫȯȱọőȍòỏơớợờởỡȏōṓṑǫǭõṍṏȭǿœṕṗŕřŗṙṛṝȑȓṟśṥšṧşŝșṡṣßťţṱțẗṫṭṯúŭǔûṷüǘǚǜǖṳụűȕùủưứựừửữȗūṻųůũṹṵṿṽẃŵẅẇẉẁẍẋýŷÿẏỵỳỷȳẙỹźžẑżẓẕǯ’'\s\-]+$/,
	simpletext: /^[^\r\n\t\f!#\$%&\+<=>\?@\[\\\]\^_`\{\|\}~˘¤§¨°˛´ˇ¸˝×÷]*$/,
    password: /^(?=.{8,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W])/,
    email: /^[a-z0-9._%+-]+@([a-z0-9-]+\.)+[a-z]{2,3}$/i,
    hasPOBox: /[p]+(ost)*\.*\s*[o|0]+(ffice)*\.*\s*b[o|0]x/ig,
    ordernumber: /^[0-9a-z\s-\(\)#]*$/i,
    cvn: /^\d{3,4}$/,
	alphanumeric: /^[a-z0-9]+$/i,
	city: /^[A-ZÀÁÂÃÄÅĀĂĄǍȀȂȦǠẠḀǺḂḄḆĆČÇḈĈĊĎḐḒḊḌḎÐÉĔĚȨḜÊẾỆỀỂỄḘËĖẸȄÈẺȆĒḖḔĘẼḚḞḟǴĞǦĢĜĠḠḪȞḨĤḦḢḤÍĬǏÎÏḮİỊȈÌỈȊĪĮĨĴǰĵḰǨĶḲḴĹĽĻḼḶḸḺŁḾṀṂŃŇŅṊṄṆǸÑÓŎǑÔỐỘỒỔỖÖȪȮȰỌŐȌÒỎƠỚỢỜỞỠȎŌṒṐǪǬÕṌṎȬǾŒṔṖŔŘŖṘṚṜȐȒṞŚṤŠṦŞŜȘṠṢŤŢṰȚṪṬṮÚŬǓÛṶÜǗǙǛǕṲỤŰȔÙỦƯỨỰỪỬỮȖŪṺŲŮŨṸṴẂŴẄẆẈẀẌẊÝŶŸẎỴỲỶȲỸŹŽẐŻẒẔǮa-zàáâãäåāăąǎȀȂȦǠạḀǻḁḃḅḇćčçḉĉċďḑḓḋḍḏðéĕěȩḝêếệềểễḙëėẹȅèẻȇēḗḕęẽḛḟǵğǧģĝġḡḫȟḩĥḧḣḥẖíĭǐîïḯịȉìỉȋīįĩḭĵḱǩķḳḵĺľļḽḷḹḻłḿṁṃńňņṋṅṇǹñóŏǒôốộồổỗöȫȯȱọőȍòỏơớợờởỡȏōṓṑǫǭõṍṏȭǿœṕṗŕřŗṙṛṝȑȓṟśṥšṧşŝșṡṣßťţṱțẗṫṭṯúŭǔûṷüǘǚǜǖṳụűȕùủưứựừửữȗūṻųůũṹṵṿṽẃŵẅẇẉẁẍẋýŷÿẏỵỳỷȳẙỹźžẑżẓẕǯ’'\s\-]+$/,
    // specialcharacterReplace: Resources.ADDRESS_REGEX
};

// var handleFormSubmitted = false;
// var handleFormFieldValidation = false;


var controlLetterMappingJSON = {
	0: 'T',
	1: 'R',
	2: 'W',
	3: 'A',
	4: 'G',
	5: 'M',
	6: 'Y',
	7: 'F',
	8: 'P',
	9: 'D',
	10: 'X',
	11: 'B',
	12: 'N',
	13: 'J',
	14: 'Z',
	15: 'S',
	16: 'Q',
	17: 'V',
	18: 'H',
	19: 'L',
	20: 'C',
	21: 'K',
	22: 'E'
};

function updateDescribedBy(element, descriptionId, shouldAdd) {
	var $element = $(element);
	var describedBy = ($element.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
	var descriptionIndex = describedBy.indexOf(descriptionId);

	if (shouldAdd && descriptionIndex === -1) {
		describedBy.push(descriptionId);
	} else if (!shouldAdd && descriptionIndex !== -1) {
		describedBy.splice(descriptionIndex, 1);
	}

	if (describedBy.length) {
		$element.attr('aria-describedby', describedBy.join(' '));
	} else {
		$element.removeAttr('aria-describedby');
	}
}

// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
			if(!$(element).val() && !$(element).hasClass('this-is-invalid') && !$(element).closest('form').hasClass('submitted-error')) {
				$(element).removeClass('error');
				if (element.id) {
					$(element).closest('form').find('[id="' + element.id + '-error"]').remove();
				} else {
					$(element).closest('.form-row').find('.error').remove();
				}
				$(element).attr('aria-invalid', 'false');
				if (element.id) {
					updateDescribedBy(element, element.id + '-error', false);
				}
				if($('body').hasClass('checkout_page')) {
					$(element).closest('.field-wrapper').find('.icon-close').remove();
				}
			} else if ($(element).closest('form').hasClass('submitted-error')) {
				$('.error').removeClass('make-invisible');
			} else {
				$(element).closest('.form-row').find('.error').removeClass('make-invisible');
				if($('body').hasClass('checkout_page')) {
					$(element).closest('.field-wrapper').find('.icon-close').remove();
				}
			}
		
        if(element.closest('#nars-pro-signup-form') == null){
        	var currentForm = element.closest('form'),
        		$country = $(currentForm).find('.country option:selected').val();
        	if($country == undefined || $country.length == 0){
    			$country = $(currentForm).find('input[name$="_country"]').val();
    		}
        	if($country != undefined) {
        		$country = $country.toLowerCase();
        		if ($country == "gb") {
        			if(element.id == $('input[id$="_postal"]').attr('id')){
        				var postalVal = element.value;
        				element.value = postalVal.toUpperCase();
        				var validInput = postalVal.slice(-4);
        				if(validInput.slice(0,1) != ' '){
        					var endChar = postalVal.slice(-3);
        					var startChar = postalVal.slice(0,-3);
        					var result = startChar+' '+endChar;
        					result = result.toUpperCase();
        					element.value = $.trim(result);
        				}
        			}
        		}
        	}
            if (!this.checkable(element)) {
                this.element(element);
            }
        }
		
    },
	
    errorPlacement: function(error, element) {
		var $element = $(element);
		if ($element.attr('id')) {
			var errorId = $element.attr('id') + '-error';
			error.attr('id', errorId);
			$element.attr('aria-invalid', 'true');
			updateDescribedBy(element, errorId, true);
			$element.closest('form').find('[id="' + errorId + '"]').not(error).remove();
		}

		if ($(element).hasClass('create-password')) {
			$(element).addClass('this-is-invalid');
		}

		if(!$(element).val()  && !$(element).hasClass('this-is-invalid') || ($(element).attr('type') === 'password' && !$(element).hasClass('create-password'))) {
			$(element).closest('.form-row').find('.error').addClass('make-invisible');
		}
		setTimeout(() => {
			if(!$(element).closest('form').hasClass('submitted-error') && !$(element).val()  && !$(element).hasClass('this-is-invalid')) {
				$(element).closest('.form-row').find('.error').addClass('make-invisible');
				$(element).removeClass('error');
				$(element).attr('aria-invalid', 'false');
				if (element.id) {
					updateDescribedBy(element, element.id + '-error', false);
				}
			}
		}, 5);

		if ($(element).hasClass('this-is-invalid') || $(element).closest('form').hasClass('submitted-error')) {
			if(element.hasClass("id-group")){
				$('.error-msg').empty().append(error);
			} else if(element.hasClass("enhanced-input")){
				error.insertBefore($(element).parent('.material_input'));	
			} else if(element.hasClass("termsandconditions") && $('body').hasClass('checkout_page')){
				error.insertAfter($(element).parents('.order-summary-footer'));	
			} else {
				error.insertBefore($(element));
				if($('body').hasClass('checkout_page') && !$(element).closest('.form-row').find('.close-icon').length) {
					$('<i class="icon-close"></i>').insertBefore($(element));
				}
			}
		}

    },
	unhighlight: function(element, errorClass, validClass) {
		var $element = $(element);
		$element.removeClass(errorClass).addClass(validClass).attr('aria-invalid', 'false');
		if (element.id) {
			var errorId = element.id + '-error';
			$element.closest('form').find('[id="' + errorId + '"]').remove();
			updateDescribedBy(element, errorId, false);
		}
	},
    ignore: ":hidden:not('.hiddenRecaptcha'), .ignore, .adyen-checkout__card__holderName__input"
};

var changeFieldValidation  = function() {
	var inputfield = 'input'
	$(inputfield).length && $(inputfield).each(function(){
		var previousValue = $(this).val();
		if (previousValue !== '') {
			$(inputfield).on('input', function() {
				var currentValue = $(this).val();
				if (currentValue === '') {
					$(this).addClass('this-is-invalid');
				} else {
					$(this).removeClass('this-is-invalid');
				}
			});
		}
	});
}


$(window).on('load', function() {
	changeFieldValidation();
});

/**
 * @function
 * @description Validates a given credit card if it has the correct format
 * @param {String} value of credit card which will be validated
 */
var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
    var country = $(el).closest('form').find('.country option:selected').val();
    var isValid;
    // Added to handle scenario having no country dropdown
	if(country == undefined || country.length == 0){
		country = $(el).closest('form').find('input[name$="_country"]').val();
	}
	
	if (country == undefined || country.length === 0 || !regex.phone[country.toLowerCase()]) {
		var country = 'other';
	}

	var isOptional = this.optional(el);
	if($('.contact-us-form input[id="phone"]').length || $('input[id$="_narspro_phone"]').length){
		isValid = true;
	}else{
		if($(el).attr('data-country-code') !== undefined && $(el).attr('data-country-code') !== '' ){
			isValid = true
		} else {
			isValid = true
		}
		if(country != undefined) {
			if(isValid === true) {
				var rgx = new RegExp(regex.phone[country.toLowerCase()]);
				isValid = rgx.test($.trim(value));
			}
		}
	}

	
    // format the phone number
    //$(el).val(value.replace(/^([\d+]{3})[\s-]*(\d{4})[\s-]*(\d+)$/, "$1 $2 $3"));
    $(el).val(value.replace(/\s/g,''));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
    return isOptional || isValid;
};

var phoneError = function(value,el){
	
	if(el.closest('#nars-pro-signup-form') == null){
		var errorMsg = Resources.INVALID_PHONE;
		var countryCodeExample = '';
		var errorMessage = '';
		var country = $(el).closest('form').find('.country option:selected').val();
		
		if(country == undefined || country.length == 0){
			country = $(el).closest('form').find('input[name$="_country"]').val();
		}
		if(country != undefined) {	
			countryCodeExample = util.getExamplePhoneNumber(country);
			errorMessage = errorMsg;
		} else {
			errorMessage = errorMsg;
		}
		return errorMessage;
	}
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value, el) {
    var isValid = regex.notCC.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
    return isValid;
};

/**
 * @function
 * @description Validates that a name contains no special characters, except for "-"
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateName = function (value, el) {
    var isValid = regex.name.test($.trim(value));
	if (!$(el).closest('form').hasClass('news-letter-form')) {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
	}
	if ($(el).closest('form').hasClass('news-letter-form') && value !== '') {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
	}
    return isValid;
};

var firstnameErrorMsg = function (value, el) {
	var message;
	if ($(el).closest('form').hasClass('news-letter-form')) {
		if ($(el).val() === '') {
			message = Resources.VALIDATE_REQUIRED;
		} else {
			message = Resources.INVALID_FIRSTNAME;
		}
	} else {
		message = Resources.INVALID_FIRSTNAME;
	}
	return message;
}

var lastnameErrorMsg = function (value, el) {
	var message;
	if ($(el).closest('form').hasClass('news-letter-form')) {
		if ($(el).val() === '') {
			message = Resources.VALIDATE_REQUIRED;
		} else {
			message = Resources.INVALID_LASTNAME;
		}
	} else {
		message = Resources.INVALID_LASTNAME;
	}
	return message;
}



var validateLastName2 = function (value, el) {
	var isValid = regex.name.test($.trim(value));
	if (typeof value === 'string' && value === '') {
		return true; // return true if empty string provided
	} else {
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
		return isValid;
	}
};




/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phonenumber', validatePhone, phoneError);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateName, Resources.INVALID_OWNER);

/**
 * Add First and Last Name validation method to jQuery validation plugin.
 * Text fields must have 'firstname' or 'lastname' css class to be validated.
 */
$.validator.addMethod('firstname', validateName, firstnameErrorMsg);
$.validator.addMethod('lastname', validateName, lastnameErrorMsg);
$.validator.addMethod('lastname2', validateLastName2, lastnameErrorMsg);
$.validator.addMethod('fullname', validateName, simpleTextMessage);
$.validator.addMethod('simpletext', function (value, el) {
    var isValid = regex.simpletext.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
    return isValid;
}, simpleTextMessage);
$.validator.addMethod('city', function (value, el) {
    var isValid = regex.city.test($.trim(value));   
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
    return isValid; 
}, simpleTextMessage);
// $.validator.addMethod('specialtextReplace', function (value,element) {
// 	for (var i=0; i < regex.specialcharacterReplace.length; i++){
//         var specialCharacterRegex = new RegExp(regex.specialcharacterReplace[i].regex,"g");
//         value = value.replace(specialCharacterRegex,regex.specialcharacterReplace[i].replacement);
//     }
//     var replacedValue = $.trim(value);
//     $(element).val(replacedValue);
//     var isValid = regex.simpletext.test(replacedValue);
//     return isValid;
// }, simpleTextMessage);

/*
 *
@param = size (en bytes) 
@element = element to validate (<input>)
@value = value of the element (file name)
 */
$.validator.addMethod('filesize', function(value, element, param) {
    return this.optional(element) || (element.files[0].size <= param) 
}, $.validator.format( Resources.VALIDATE_SIZE ));

/*
*
@param = extension (add file extension separated by |) 
@element = element to validate (<input>)
@value = value of the element (file name)
*/
$.validator.addMethod( "extension", function( value, element, param ) {
	param = typeof param === "string" ? param.replace( /,/g, "|" ) : "png|jpe?g|gif";
	value = value.toLowerCase();
	return this.optional( element ) || value.match( new RegExp( "\\.(" + param + ")$", "i" ) );
}, $.validator.format( Resources.MISSING_FILE ) );

$.validator.addClassRules({
    city: {
    	city: true
    },
    address1: {
    	simpletext: true,
    	address: true
    },
    address2: {
    	simpletext: true,
    	address: true
    },
    province: {
    	simpletext: true
    },
    hiddenRecaptcha:{
    	reCaptcha : true
    },
    requiredDoc:{
    	required: true,
    	extension: "jpg|jpeg|png|gif|pdf",
    	filesize: maxFileSize
    },
    idDoc:{
    	required: true,
    	extension: "jpg|jpeg|png|gif|pdf",
    	filesize: maxFileSize
    }
});

/**
 * Add Alphanumeric method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated.
 */
$.validator.addMethod('alphanumeric', function(value, el){
	var isValid = regex.alphanumeric.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, simpleTextMessage);

/**
 * Modify password validation method of jQuery validation plugin.
 * Text fields must have 'password' css class to be validated.
 */
$.validator.addMethod('create-password', function(value, el){
	var isValid = regex.password.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.VALIDATE_PASSWORD);

var passwordMessageempty = function(value, el) {
	var message;
	if ($(el).val() === '') {
		message = Resources.VALIDATE_REQUIRED;
	} else {
		message = Resources.VALIDATE_PASSWORD_CONFIRM
	}
	return message;
};

$.validator.addMethod('passwordconfirm', function(value, el){
	var isValid = regex.password.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, passwordMessageempty);



/**
 * Modify email validation method of jQuery validation plugin.
 * Text fields must have 'email' css class to be validated.
 */
$.validator.addMethod('email', function(value, el){
	var isValid = regex.email.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, confirmEmailErrorMsg);

var confirmEmailErrorMsg = function (value, el) {
	var message;
	if($(el).val() === '') {
		message = Resources.VALIDATE_REQUIRED;
	} else {
		message = Resources.VALIDATE_EMAIL;
	}
	return message;
}

$.validator.addMethod('emailconfirm', function(value, el){
	var isValid = regex.email.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, confirmEmailErrorMsg);

/**
 * Add Modify National ID field validation method to jQuery validation plugin.
 */

if (!$(".pt_checkout").length) {
	$.validator.addMethod('nationalidnumber', function (value, el) {
		var nationalId = $(el).closest('form').find('.input-select.nationalidtype option:selected');
		var nationalIdSelected = nationalId.val();
		var nationalIdRegex = nationalId.data('nationalidregex');
		nationalIdRegex = new RegExp(nationalIdRegex);
		var isValid = nationalIdRegex.test($.trim(value));

		if (isValid == true) {
			var lastDigitInValue = value.charAt(value.length - 1);
			if (nationalIdSelected === Constants.IDENTITY_DOC_NIF) {
				var digitsInValue = value.substring(0, value.length - 1);
				if ((value === "00000000T") || (value === "00000001R") || (value === "99999999R")) {
					isValid = false;
				} else if (controlLetterMappingJSON[digitsInValue % 23] === lastDigitInValue) {
					isValid = true;
				} else {
					isValid = false;
				}
			}
			if (nationalIdSelected === Constants.IDENTITY_DOC_NIE) {
				var valueAfterReplace = replaceFirstChar(value)[0];
				var isValidFirstChar = replaceFirstChar(value)[1];
				var digitsInValue = valueAfterReplace.substring(0, value.length - 1);
				if (value === "X0000000T") {
					isValid = false;
				} else if (isValidFirstChar && (controlLetterMappingJSON[digitsInValue % 23] === lastDigitInValue)) {
					isValid = true;
				} else {
					isValid = false;
				}
			}
		}
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
		return isValid;
	}, Resources.VALIDATE_NATIONAL_ID);
}

if ($(".pt_checkout").length ||  $("#applepay-container").length) {
	$.validator.addMethod('nationalidnumber', function (value, el) {
		var nationalId = $(el),
			nationalIdSelected = nationalId.val(),
			nationalIdRegex = nationalId.data('nationalidregex'),
			nationalIdRegSplit = nationalIdRegex.split(/~/),
			nationalIdType = nationalId.data('nationaltype'),
			nationalIdList = nationalIdType.split(/,/),
			lastRegValidate = new RegExp(nationalIdRegSplit[nationalIdRegSplit.length - 1]),
			isValid = lastRegValidate.test($.trim(nationalIdSelected));

		$.each(nationalIdRegSplit, function (index, val) {
			var newNationalId = new RegExp(val);
			if (newNationalId.test(nationalIdSelected) === true) {
				if (isValid == true) {
					var lastDigitInValue = value.charAt(value.length - 1);
					if (nationalIdList[index] === Constants.IDENTITY_DOC_NIF) {
						var digitsInValue = value.substring(0, value.length - 1);
						if ((value === "00000000T") || (value === "00000001R") || (value === "99999999R")) {
							isValid = false;
						} else if (controlLetterMappingJSON[digitsInValue % 23] === lastDigitInValue) {
							isValid = true;
						} else {
							isValid = false;
						}
					}
					if (nationalIdList[index] === Constants.IDENTITY_DOC_NIE) {
						var valueAfterReplace = replaceFirstChar(value)[0];
						var isValidFirstChar = replaceFirstChar(value)[1];
						var digitsInValue = valueAfterReplace.substring(0, value.length - 1);
						if (value === "X0000000T") {
							isValid = false;
						} else if (isValidFirstChar && (controlLetterMappingJSON[digitsInValue % 23] === lastDigitInValue)) {
							isValid = true;
						} else {
							isValid = false;
						}
					}
				}
			}
		});
		if(!isValid) {
			$(el).addClass('this-is-invalid');
		}
		return isValid;
	}, Resources.VALIDATE_NATIONAL_ID);
}


/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

/**
 * Add CC number validation method to jQuery validation plugin.
 * Text fields must have 'number' css class to be validated
 */
$.validator.addMethod('number', function (value, el) {	// number == Credit card number
	var isValid = luhnCheck($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.VALIDATE_NUMBER);

/**
 * Add CVN number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated
 */
$.validator.addMethod('cvn', function (value, el) {
	var isValid = regex.cvn.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.VALIDATE_CVN);

/**
 * Add Order number validation method to jQuery validation plugin.
 * Text fields must have 'ordernumber' css class to be validated
 */
$.validator.addMethod('ordernumber', function (value, el) {
	var isValid = regex.ordernumber.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}, Resources.INVALID_ORDER_NUMBER);

/**
 * Add equal value validation method to jQuery validation plugin.
 * Text fields must have 'equal-to' css class to be validated
 */
$.validator.addMethod('equal-to', function (value, el) {
	var equalTo = $(el).attr('equal-to');
	var $equalToEl = $(el).closest('form').find(equalTo);
	
	return  value === $equalToEl.val();
	
}, function(value, el){
	var message = $(el).attr('data-required-text');
	$(el).addClass('this-is-invalid');
    return message || Resources.VALIDATE_EQUALTO
});

/**
 * Add address validation method to jQuery validation plugin.
 * Text fields must have 'address1' css class to be validated
 */
$.validator.addMethod('address', function (value, el) {
	// check 'PO BOX' value in string and complement result
    var isValid = !$.trim(value).match(regex.hasPOBox);
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
    return isValid;
}, Resources.ADDRESS_PO_BOX_ERROR);

/**
 * Add zipcode validation method to jQuery validation plugin.
 * Text fields must have 'zipcode' css class to be validated
 */
$.validator.addMethod('postal', function (value, el) {
	var $form = $(el).closest('fieldset');
	var $country = $form.find('select[name$="_country"]');
	// Added to handle scenario having no country dropdown
	if($country.val() == null){
		$country = $form.find('input[name$="_country"]');
	}
	var selectedCountry = $country.length > 0 ? $country.val() : 'us';
	
	var rgx = null;
	var isValid = false;
	if($(el).hasClass('global-zip')){
		// if universal, it accepts both US and CN values
		isValid = regex.postal['us'].test($.trim(value)) || regex.postal['cn'].test($.trim(value));
	} else {
		if ($country.val() != undefined) {
			if(selectedCountry.toLowerCase() != ''){
				rgx = regex.postal[selectedCountry.toLowerCase()];
				isValid = rgx.test($.trim(value));
			}else{
				isValid = true;
			}
		}
	}
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	
	return isValid;
}, Resources.INVALID_POSTAL);

/**
 * Add postcode validation method to jQuery validation plugin.
 * Text fields must have 'postcode' css class to be validated
 * Adding this for China addresses
 */
$.validator.addMethod('postcode', function (value, el) {
	var $form = $(el).closest('fieldset');
	var $country = $form.find('select[name$="_country"]');
	if($country.val() == null){
		$country = $form.find('input[name$="_country"]');
	}
	var selectedCountry = $country.length > 0 ? $country.val() : 'us'; 

	var rgx = regex.postal[selectedCountry];
	var isValid = rgx.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}

	return isValid;
}, Resources.INVALID_POSTAL);

$.validator.addMethod('reCaptcha', function (value, el) {
	return !(grecaptcha && grecaptcha.getResponse() == '');
});

$.validator.addMethod('checkList', function (value, el) {
	return $(el).is(":checked");    
}, requiredMessage);

function replaceFirstChar(value){
	var isValidFirstChar = true;
	var valueAfterReplace;
	var firstChar = value.charAt(0);
	switch(firstChar){
		case 'X':
			valueAfterReplace = value.replace(firstChar,0);
			break;
		case 'Y':
			valueAfterReplace = value.replace(firstChar,1);
			break;
		case 'Z':
			valueAfterReplace = value.replace(firstChar,2);
			break;
		default:
			valueAfterReplace = value;
			isValidFirstChar = false;
	}
	return [valueAfterReplace,isValidFirstChar];
}


var requiredMessage = function(value, el) {
    var message; 
	if ($(el).hasClass('passwordconfirm') || $(el).hasClass('newpasswordconfirm')) {
		message = Resources.VALIDATE_PASSWORD_EMPTY;
	} else if ($(el).closest('form').attr('id') == 'dwfrm_login') {
		message = Resources.VALIDATE_REQUIRED 
	} else if ($(el).hasClass('email') && $(el).val() === '' || ($(el).hasClass('emailconfirm') && $(el).val() === '') ) {
		message = Resources.VALIDATE_REQUIRED 
	} else if ($(el).hasClass('address1') && $(el).val() === '') {
		message = Resources.VALIDATE_REQUIRED 
	} else if ($(el).hasClass('city') && $(el).val() === '') {
		message = Resources.VALIDATE_REQUIRED 
	} else if ($(el).hasClass('postal') && $(el).val() === '') {
		message = Resources.VALIDATE_REQUIRED 
	}
	 else {
		message = $(el).attr('data-required-text');
	}
    return message || Resources.VALIDATE_REQUIRED
};

var simpleTextMessage = function(value, el) {
	var message;
	if($(el).hasClass('city') && $(el).val() === '') {
		message = Resources.VALIDATE_REQUIRED;
	} else {
		message = $(el).attr('data-required-text')
	}
	return message || Resources.VALIDATE_REQUIRED
};



var passwordMessage = function(value, el) {
    var message = $(el).attr('data-required-text');
    return message || Resources.VALIDATE_PASSWORD
};

var maxLengthMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || $.validator.format(Resources.VALIDATE_MAXLENGTH)
};

var minLengthMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || $.validator.format(Resources.VALIDATE_MINLENGTH)
};

$.validator.addClassRules({	
	checkList: {
		required: true
	}
});

$.extend($.validator.messages, {
    required: requiredMessage,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    address1: Resources.ADDRESS_PO_BOX_ERROR,
    password: passwordMessage,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: maxLengthMessage,
    minlength: minLengthMessage,
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN),
    postal: Resources.INVALID_POSTAL,
    message: Resources.INVALID_MESSAGE,
    fullname: simpleTextMessage,
    simpletext: simpleTextMessage,
	alphanumeric: simpleTextMessage,
	city: simpleTextMessage,
    reCaptcha: Resources.VALIDATE_CAPTCHA
});


var stateValidation = function(element){
	var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
	var customstateRow = $(element).parents('.enhancedinput-select').find('label');
	if( $(element).val() == '' || $(element).find('.ui-selectmenu-text').text() == "Select an option"){
		$(element).addClass('error');
		$(element).next().addClass('error-dropdown');
		customstateRow.next('.error-placement').remove();
		$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertAfter(customstateRow);
		$(element).find('.ui-selectmenu-button').addClass('dropdownerror');
	} else {
		$(element).removeClass('error');
		$(element).next().removeClass('error-dropdown');
		customstateRow.next('.error-placement').remove();
		$(element).find('.ui-selectmenu-button').removeClass('dropdownerror');
	}
}

var inputValidation = function(element){
	var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
	var customstateRow = $(element).parents('.enhancedinput-text').find('label:first');
	if ($(element).val() === '') {
		$(element).addClass('error');
		customstateRow.next('.error-placement').remove();
		$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertAfter(customstateRow);
	} else {
		$(element).removeClass('error');
		customstateRow.next('.error-placement').remove();
	}
}

var fileValidation = function(element){
	var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
	var customstateRow = $(element);
	if(!($(element).hasClass("appended"))){
		$(element).find(".narspro-input-upload").addClass('error');
		customstateRow.prev('.error-placement').remove();
		$(element).parents(".fileupload-wrap").next(".error.file-validation").hide();  
		$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertBefore(customstateRow);
	} else {
		$(element).find(".narspro-input-upload").removeClass('error');
		customstateRow.prev('.error-placement').remove();
	}
}

var checkboxvalidation = function(element){
	var validationMessage = $('.narspro-artistsignupform').attr('data-required-message');
	var customstateRow = $(element).parents('.narspro-agreement');
	if ($(element).is(":checked")) {
		customstateRow.prev('.error-placement').remove();
		$(element).removeClass('error');
		
    }
    else {
		customstateRow.prev('.error-placement').remove();
		$(element).addClass('error');
        $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ validationMessage +'</span></div>').insertBefore(customstateRow);
    }
}

var customInputValidation = function(element){
	var validationMessage = $(element).attr('data-required-text');
	var $errorElement = $(element).closest('.field-wrapper').find('span.error');
	if ($(element).val() === '') {
		$(element).addClass('error');
		$errorElement.remove();
		var errorId = element.id ? element.id + '-error' : '';
		$(element).attr('aria-invalid', 'true');
		if (errorId) {
			updateDescribedBy(element, errorId, true);
		}
		$('<span class="error"></span>').attr('id', errorId).text(validationMessage).insertBefore($(element));
	} else {
		$(element).removeClass('error');
		$errorElement.remove();
		$(element).attr('aria-invalid', 'false');
		if (element.id) {
			updateDescribedBy(element, element.id + '-error', false);
		}
	}
}

var validator = {
    regex: regex,
    settings: settings,
    init: function () {
        var _self = this;
        $('form:not(.suppress)').each(function () {
        	_self.initForm(this);
        });
    },
    initForm: function (f) {
    	var _self = this;
        var $form = $(f);
    	var $submitForm = $form.find('button[type="submit"]:not(.ignore)');
    	var fp = formPrepare();
		$form.find('button[type="submit"]').on('click', function(e){
			$form.addClass('submitted-error');
		});

    	fp.init({
    		formSelector: $form,
    		continueSelector: $submitForm
		}, _self.settings);
    	
    	$('.ask-the-artist .input-select').on('change', function(){
    		$('.ask-the-artist form').valid();
    	});

    	$('input[id$="_postal"]').on('keyup', function(){
			if($('select[id$="_country"]').val() == 'NL') {
				var postalVal = $(this).val().split(" ").join("");
				if (postalVal.length > 0) {
					postalVal = postalVal.match(new RegExp('.{1,4}', 'g')).join(" ");
				}
				$(this).val(postalVal);
			}
			if($('input[id$="_country"]').val() == 'IE') {
				var postalVal = $(this).val().split(" ").join("");
				if (postalVal.length > 0) {
					postalVal = postalVal.replace(/(^(?:[A-Z0-9]){3})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
				}
				$(this).val(postalVal);
			}
    		var currentObject = $(this);
    		let val = $(currentObject).val().toUpperCase();
    		var $length = val.length,
    			$form = $(currentObject).closest('form'),
    			$country = $form.find('.country option:selected').val();
    		if($country == undefined || $country.length == 0){
    			$country = $form.find('input[name$="_country"]').val();
    		}
    		$country = $country ? $country.toLowerCase() : '';
    		if ($country != "gb"){
    			switch($length){
    				case 2:
    					if($country == "pl"){
    						val = val+'-';
    					}
    					break;
    				case 3:
    					if($country == "mt"){
    						val = val+'-';
    					} else if($country == "cz"||$country == "sk"||$country == "gr"||$country == "se"){
    						val = val+' ';
    					}
    					break;
    				case 4:
    					if($country == "pt"){
							val = val+'-';
						}
    					break;
    				default:
    					break;
    			}
    			$(this).val(val);
			}
    	});
    	$submitForm.on('click', function(e){
			
    		if($form.find('.error').length == 0){
    			return;
    		} else {
				$form.addClass('submitted-error');
			}
			var $invalidField = $form.find("span.error:first");
			var $isModalVisible = $(".reveal-overlay").is(":visible");
			var $invalidModalField = $(".modal-body .error");
			var $headerOffset = $('#minimized-header-container').length ? $('#minimized-header-container').outerHeight() + 50 : 50;			  
			// to set scroll position and focus on first invalid field
			if(!$form.valid() && !$isModalVisible && $invalidField.length) {
				// to check whether error element visible or not to calculate the correct offset value
				if($invalidField.is(":hidden") && $form.find("span.error").length) {
					$form.find("span.error").each(function() {
						// to get next visible error element
						if($(this).is(":visible")) {
							$invalidField = $(this);
							return;
						}
					});
				}
				$('html, body').animate({
					scrollTop: $invalidField.offset().top - $headerOffset
				}, 500);
				$invalidField.focus();
			}
			if(!$form.valid() && $isModalVisible && $invalidModalField.length) {
				var dialogError = $invalidModalField.first().offset().top - $(".reveal").offset().top;
				util.scrollToError($('.reveal-overlay'), dialogError, 500);
			}
		});
		if ($('select[id$="_country"]').length > 0) {
			$('select[id$="_country"] option:first-child').attr("disabled","disabled");
		}
	},
    initStateValidation:function() {
		$('.enhancedinput-select select').on('selectmenuchange', function () {
			stateValidation($(this));	
		});
	},
	initgenericValidation: function(element) {
		stateValidation(element);
	},
	initinputValidation: function(element) {
		inputValidation(element);
	},
	initfileValidation: function(element) {
		fileValidation(element);
	}, 
	initcheckboxValidation: function(element) {
		checkboxvalidation(element);
	},
	initFormprep: function(e) {
		var fp = formPrepare();
		fp.validateEl(e);
    	
	},
	initEmptyInputValidation: function(element) {
		customInputValidation(element);
	},

	changeFieldValidation: function(element) {
		changeFieldValidation(element);
	}
};

export default validator;